import router from ".";
import { getToken, getTokenCC } from "@/api/login";
import store from "@/store";

router.beforeEach(async (to, from, next) => {
  document.title = store.getters.userDetail.names || '门店管理系统'
  const hasToken = getToken();
  const hasTokenCC = getTokenCC()
  if (hasToken) {
    if (to.path == "/login" && !to.query.uid) {
      next({ path: "/" });
    } else {
      next();
    }
  } else {
    if (to.path == '/login') {
      next();
    } else {
      next("/login");
    }
  }
});
